import * as requestFromServer from "./crud";
import {ordersSlice, callTypes} from "./slices";
import {convertFilter} from "../../../utils/commonUtils";

const {actions} = ordersSlice;

export const fetchOrders = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const _filter = convertFilter(queryParams);

  return requestFromServer
    .findOrders(_filter)
    .then(response => {
      const {pageInfo: {totalCnt}, orderList} = response;
      dispatch(actions.ordersFetched({totalCnt, orderList}));
    })
    .catch(error => {
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const fetchOrder = id => dispatch => {
  if (!id) {
    return dispatch(actions.orderFetched({link: undefined}));
  }
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .getOrderById(id)
    .then(response => {
      const order = response;
      dispatch(actions.orderFetched({order}));
    })
    .catch(error => {
      error.clientMessage = "Can't find link";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};
